import React, { useMemo } from 'react';
import { Alert, Button, Card, Descriptions, Empty, Space, Table, Tag, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { DURUM_RENK, serbestSayi, useAktifYukle, zamanDamgasi } from './biOrtak';

const { Text } = Typography;

const durumEtiketi = (v) => (v ? <Tag color={DURUM_RENK[v] || 'default'}>{v}</Tag> : null);
const sayiHucre = (v) => <span className="nf-amount">{serbestSayi(v)}</span>;

const KOLONLAR = [
  { title: 'Kontrol', dataIndex: 'ad', key: 'ad', width: 300 },
  { title: 'Beklenen', dataIndex: 'beklenen', key: 'beklenen', width: 170, align: 'right', render: sayiHucre },
  { title: 'Bulunan', dataIndex: 'bulunan', key: 'bulunan', width: 170, align: 'right', render: sayiHucre },
  { title: 'Fark', dataIndex: 'fark', key: 'fark', width: 140, align: 'right',
    render: (v) => (v !== null && v !== undefined && v !== 0 && v !== '0' && v !== '0.00'
      ? <Text type="danger" className="nf-amount">{serbestSayi(v)}</Text> : sayiHucre(v)) },
  { title: 'Adet', dataIndex: 'adet', key: 'adet', width: 90, align: 'right', render: sayiHucre },
  { title: 'Durum', dataIndex: 'durum', key: 'durum', width: 95, render: durumEtiketi },
  { title: 'Not', dataIndex: 'not', key: 'not', width: 380, render: (v) => (v ? <span style={{ whiteSpace: 'pre-wrap' }}>{String(v)}</span> : '') },
];
const GENISLIK = KOLONLAR.reduce((t, k) => t + k.width, 0);

/**
 * Kontrol sekmesi: /bi-v2/{key}/kontrol — çerçevenin genel denetimleri (satır, toplam, dağıtım kovaları,
 * kabin payı = kaynak tutar) ve raporun kendi kaynak mutabakatları. Süzgeçlerden bağımsızdır (tüm rapor).
 */
export default function BiKontrol({ api, rapor, aktif, surum }) {
  const anahtar = rapor ? JSON.stringify([rapor.key, surum]) : null;
  const { veri, yukleniyor, hata: hataMetni, yeniden } = useAktifYukle(aktif, anahtar, () => api.rapor(rapor.key, 'kontrol'));

  const sayac = useMemo(() => {
    const s = {};
    [...(veri?.genel || []), ...(veri?.rapor || [])].forEach((k) => { s[k.durum] = (s[k.durum] || 0) + 1; });
    return s;
  }, [veri]);

  const tablo = (liste, bos) => (
    <Table rowKey={(r, i) => `${r.ad}-${i}`} size="small" columns={KOLONLAR} dataSource={liste || []} pagination={false}
      scroll={{ x: GENISLIK }} loading={yukleniyor} locale={{ emptyText: <Empty description={bos} /> }}
      rowClassName={(r) => (r.durum === 'HATA' ? 'bi-kontrol-hata' : (r.durum === 'UYARI' ? 'bi-kontrol-uyari' : ''))} />
  );

  return (
    <div>
      <Space wrap style={{ marginBottom: 10 }}>
        <Button icon={<ReloadOutlined />} onClick={yeniden} loading={yukleniyor}>Yeniden yükle</Button>
        {Object.entries(sayac).map(([d, n]) => <Tag key={d} color={DURUM_RENK[d] || 'default'}>{d}: {n}</Tag>)}
        <Text type="secondary">Kontroller süzgeçlerden bağımsızdır; raporun tamamı üzerinde çalışır.</Text>
      </Space>
      {hataMetni && <Alert type="error" showIcon style={{ marginBottom: 10 }} message="Kontroller alınamadı" description={hataMetni} />}
      {veri && (
        <Descriptions size="small" column={{ xs: 1, sm: 2 }} style={{ marginBottom: 12 }} bordered>
          <Descriptions.Item label="Veri zamanı (önbellek)">{zamanDamgasi(veri.ts)}</Descriptions.Item>
          <Descriptions.Item label="Üretim süresi">{veri.sure !== null && veri.sure !== undefined
            ? `${Number(veri.sure).toLocaleString('tr-TR')} sn` : ''}</Descriptions.Item>
        </Descriptions>
      )}
      <Card size="small" title="Rapor kontrolleri (kaynak tablolarla mutabakat)" style={{ marginBottom: 12 }}>
        {tablo(veri?.rapor, 'Bu rapor için tanımlı kontrol yok')}
      </Card>
      <Card size="small" title="Genel kontroller (çerçeve)">
        {tablo(veri?.genel, 'Kayıt yok')}
      </Card>
    </div>
  );
}
